module.exports = __webpack_public_path__ + "img/1_Justin_GettyImages-985138634@3x.af8d272a.jpg";